<template>
    <div>
        <reports-base
            exportable
            reports-name="saleGoals"
            reports-title="Raport/ Realizacja celów sprzedażowych"
            component-name="SaleGoals"
            :results-phrase="resultsPhrase"
            @onExport="onExportClick"
        >
            <div class="c-thead">
                <div class="c-tw">
                    <div class="c-td is-1">
                        Data rozpoczęcia /<br />Data zakończenia
                    </div>
                    <div class="c-td is-2">Promocja (ID)</div>
                    <div class="c-td is-3">Organizator</div>
                    <div class="c-td is-4">Status promocji</div>
                    <div class="c-td is-5">Liczba sprzedanych sztuk</div>
                    <div class="c-td is-6">Osiągnięty próg</div>
                    <div class="c-td is-7">Progi</div>
                </div>
            </div>
        </reports-base>
    </div>
</template>

<script>
import ReportsBase from '@/components/reports/ReportsBase'

export default {
    name: 'SaleGoals',
    components: {
        ReportsBase
    },
    created() {
        this.$store.dispatch('setSaleGoalsDefaultMerchant')
    },
    computed: {
        resultsPhrase() {
            const shopValue = this.$store.getters.getSaleGoalsFilters.merchantIds.value
            const noShopSelected = !shopValue || shopValue?.length === 0
            return noShopSelected
                ? 'Wybierz sklep w filtrze, aby wyświetlić raport'
                : undefined
        }
    },
    methods: {
        onExportClick() {
            this.$store.dispatch('getGoalsToExcel')
        }
    }
}
</script>